/* Andersen Farms Theme - JavaScript */

(function() {
  'use strict';

  /* ==========================================================================
     Mobile Menu
     ========================================================================== */
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');
  const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');

  function openMobileMenu() {
    mobileMenu?.classList.add('active');
    mobileMenuOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenu?.classList.remove('active');
    mobileMenuOverlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  mobileMenuToggle?.addEventListener('click', openMobileMenu);
  mobileMenuClose?.addEventListener('click', closeMobileMenu);
  mobileMenuOverlay?.addEventListener('click', closeMobileMenu);

  /* ==========================================================================
     Product Gallery
     ========================================================================== */
  const productThumbnails = document.querySelectorAll('.product-thumbnail');
  const productMainImage = document.querySelector('.product-main-image img');

  productThumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      const newSrc = this.dataset.src;
      const newAlt = this.querySelector('img')?.alt || '';
      
      if (productMainImage && newSrc) {
        productMainImage.src = newSrc;
        productMainImage.alt = newAlt;
        
        productThumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });

  /* ==========================================================================
     Quantity Selector
     ========================================================================== */
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const minusBtn = selector.querySelector('[data-action="minus"]');
    const plusBtn = selector.querySelector('[data-action="plus"]');
    const input = selector.querySelector('.quantity-value');

    if (minusBtn && plusBtn && input) {
      minusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > 1) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event('change'));
        }
      });

      plusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        input.value = currentValue + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  /* ==========================================================================
     Variant Selector
     ========================================================================== */
  

  /* ==========================================================================
     Add to Cart (AJAX)
     ========================================================================== */
  const addToCartForm = document.querySelector('.product-form');
  
  addToCartForm?.addEventListener('submit', async function(e) {
    e.preventDefault();
    
    const formData = new FormData(this);
    const submitBtn = this.querySelector('[type="submit"]');
    const originalText = submitBtn?.textContent;
    
    if (submitBtn) {
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        // Update cart count in header
        updateCartCount();
        
        if (submitBtn) {
          submitBtn.textContent = 'Added!';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
          // After successful add to cart
        }
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      if (submitBtn) {
        submitBtn.textContent = 'Error - Try Again';
        submitBtn.disabled = false;
      }
    }
  });

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartCount = document.querySelector('.header-cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  /* ==========================================================================
     Newsletter Form
     ========================================================================== */
  document.querySelectorAll('.newsletter-form, .footer-newsletter-form').forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const emailInput = this.querySelector('input[type="email"]');
      const submitBtn = this.querySelector('button[type="submit"]');
      
      if (!emailInput || !submitBtn) return;
      
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Subscribing...';
      submitBtn.disabled = true;
      
      // Simulate newsletter submission (replace with actual endpoint)
      setTimeout(() => {
        submitBtn.textContent = 'Subscribed!';
        emailInput.value = '';
        
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
      }, 1000);
    });
  });

  /* ==========================================================================
     Hero Video Fallback
     ========================================================================== */
  const heroVideo = document.querySelector('.hero-media video');
  const heroFallback = document.querySelector('.hero-media .hero-fallback');
  
  if (heroVideo) {
    heroVideo.addEventListener('error', function() {
      this.style.display = 'none';
      if (heroFallback) {
        heroFallback.style.display = 'block';
      }
    });
  }

  /* ==========================================================================
     Smooth Scroll
     ========================================================================== */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  /* ==========================================================================
     Animations on Scroll
     ========================================================================== */
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const fadeInObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-visible');
        fadeInObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.fade-in-on-scroll').forEach(el => {
    fadeInObserver.observe(el);
  });

  /* ==========================================================================
     Initialize on DOM Ready
     ========================================================================== */
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize cart count
    updateCartCount();
    
    // Add loaded class for CSS transitions
    document.body.classList.add('loaded');
  });

})();

document.addEventListener('DOMContentLoaded', function () {
  const searchTrigger = document.querySelector('.header-search');
  const searchForm = document.querySelector('.header-search form');

  if (!searchTrigger || !searchForm) return;

  // Toggle on click
  searchTrigger.addEventListener('click', function (e) {
    e.stopPropagation(); // ✅ prevent document click from firing
    searchForm.classList.toggle('active');
  });

  // Prevent closing when clicking inside form
  searchForm.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  // Close when clicking anywhere else
  document.addEventListener('click', function () {
    searchForm.classList.remove('active');
  });
});